export default __webpack_public_path__ + "static/media/B0_6.c71413a6.mp3";